// Import react elements
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

// Import layout components
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

// Import hooks
import useIsMobile from "global/hooks/useIsMobile";



const Layout = () => {



    // Set isMobile from use hook 
    const isMobile = useIsMobile();



    // Set a state for the side bar open/close toggle
    const [sidebarOpen, setSidebarOpen] = useState(true);



    // Hide sidebar by default on mobile
    useEffect(() => {

        // Check if mobile size screen
        if (isMobile) {

            // It is mobile

            // Hide sidebar by default
            setSidebarOpen(false);

        }

    // Run whenever isMobile changes
    }, [isMobile]);



    // Set location to useLocation() which gives access to the current URL/location object
    const location = useLocation();



    // Set a state for the page title
    const [pageTitle, setPageTitle] = useState("");


    /* OLD - does not update title if the component updates it
    // Run on location.pathname change - to update page title - sent to Header
    useEffect(() => {

        // Set current title by reading title from `document.title` - and replace the 'Strichsuite - ' bit with nothing
        const currentTitle = document.title.replace("Strichsuite - ", "");

        // Set the pageTitle
        setPageTitle(currentTitle);

        // Update when path location or the title changes
    }, [location.pathname]);
    */


    // Keep pageTitle in sync with document.title (if title changes within component)
    useEffect(() => {

        // Get the <title> element (this is what the browser updates)
        const titleElement = document.querySelector("title");

        // Create a safe updater function
        const updateTitleFromDocument = () => {

            // Read the current document title
            const fullTitle = document.title || "";

            // Remove your prefix (fix the prefix string here)
            const cleanedTitle = fullTitle.replace("Strichsuite - ", "");

            // Store it in state so React re-renders Header
            setPageTitle(cleanedTitle);

        };

        // Update immediately on mount / route change
        updateTitleFromDocument();

        // If we can't find the title element, stop here
        if (!titleElement) {

            // Exit early
            return;

        }

        // Watch for changes to the <title> text
        const observer = new MutationObserver(() => {

            // Update whenever the title changes
            updateTitleFromDocument();

        });

        // Start observing text changes inside <title>
        observer.observe(titleElement, {

            // Observe direct text changes
            childList: true,

        });

        // Cleanup observer on unmount / dependency change
        return () => {

            // Stop observing
            observer.disconnect();

        };

    }, [location.pathname]);


    return (

        <div className="layout">

            <Sidebar toggleSidebar={() => setSidebarOpen(prev => !prev)} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} isMobile={isMobile} />

            { /* <div className={`content ${sidebarOpen ? "sidebar_open" : "sidebar_closed"}`}> */ }
            <div className={`content ${isMobile ? "is_mobile" : "is_desktop"} ${!sidebarOpen ? "sidebar_closed" : "sidebar_open"}`}>

                <Header toggleSidebar={() => setSidebarOpen(prev => !prev)} pageTitle={pageTitle} sidebarOpen={sidebarOpen} isMobile={isMobile} /> 

                <main className="main">

                    {/* This renders the page content */}
                    <Outlet /> 

                </main>

                <Footer />

            </div>

        </div>
    );
    


};

export default Layout;
